import { gql } from '@apollo/client'
import { useSort } from '@btime/react-contexts'
import React from 'react'

import { templatesClient } from '../../../../utils/apollo/api'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'

const Context = React.createContext([])
const { Provider } = Context
export const useTemplateRecordsState = () => React.useContext(Context)
export const useTemplateRecords = () => useTemplateRecordsState()?.templateRecords

const QUERY = gql`
  query TemplateRecords($page: Int, $sort: TemplateRecordSort, $filter: TemplateRecordFilter) {
    templateRecords(page: $page, sort: $sort, filter: $filter) {
      id
      document {
        id
        src
      }
      template {
        id
        name
      }
      recordId
      updatedAt
      insertedAt
    }
  }
`

const TemplateRecordLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const { data: entity } = useCurrentModal()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      sort: { field: field || 'INSERTED_AT', type: type || 'DESC' },
      filter: { entities: [entity] }
    },
    client: templatesClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default TemplateRecordLoader
